import { dateFormat } from "../../const/date";
import sanitizeHtml from "sanitize-html";

type BlogData = {
  data: {
    category: Array<string>;
    title: Array<string>;
    link: Array<string>;
    description: Array<string>;
    pubDate: Array<string>;
  }[];
};

const Blog = ({ data }: { data: BlogData[] | any[] }) => {
  const blog = ParseData({ data });

  const getTranslated = (key: string) => {
    const text = key || ""; //data json에서 호출
    const sanitizedText = sanitizeHtml(text, {
      allowedTags: ["br", "em", "span"], //허용할 태그 지정
    });
    return { __html: sanitizedText };
  };
  return (
    <div
      id="blog"
      className="relative w-full h-full bg-gradient-to-tr to-primary via-[#2b78fd] from-primary px-2 mx-auto py-14 lg:py-28 xl:pb-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20 text-white"
      >
        <h2 className="my-3 font-black manru">
          장인배관 <span className="text-point">작업사례</span>
        </h2>
        <p className="lg:text-xl ">
          실제&nbsp;작업이&nbsp;이루어지는&nbsp;모습들을
          생생히&nbsp;담아&nbsp;보여드립니다
        </p>
      </div>
      <div className="relative w-full h-fit max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-3 lg:gap-5 text-black">
        {blog.map((v, i) => (
          <div
            data-aos="fade-up"
            key={i}
            onClick={() => window.open(v.link[0])}
            className={
              i > 7
                ? "hidden lg:block relative w-full h-full"
                : "relative w-full h-full"
            }
          >
            <div className="relative w-full h-full grid bg-white p-2 md:p-3 rounded-3xl text-left border cursor-pointer transition-all duration-300 overflow-hidden">
              <p
                className={`relative w-full text-primary whitespace-nowrap overflow-hidden overflow-ellipsis lg:text-lg h-fit mb-1.5 lg:mb-3`}
              >
                {v.title[0]}
              </p>
              <small
                className={`relative w-full whitespace-nowrap md:whitespace-normal overflow-hidden overflow-ellipsis h-fit md:h-9 my-2 lg:my-0 break-words md:line-clamp-2 text-sm opacity-60`}
                dangerouslySetInnerHTML={getTranslated(v.description[0])}
                // dangerouslySetInnerHTML={{ __html: v.description[0] }}
              ></small>
              <div className="md:pt-2 lg:mt-3 3xl:mt-4 lg:flex justify-between items-end">
                <small className="hidden xl:block opacity-40 lg:text-sm">
                  {dateFormat(v.pubDate[0])}
                </small>
                <small className="text-main lg:text-sm">{v.category[0]}</small>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="text-white text-center">
        <p className="lg:text-xl my-8">
          장인배관의&nbsp;정확한&nbsp;탐지와 깔끔한&nbsp;공사&nbsp;프로세스로
          <br />
          고객님의&nbsp;누수&nbsp;고민을 해결해드립니다
        </p>
        <div className=" relative w-fit h-fit mx-auto">
          <img
            src="/images/rightNum.png"
            alt="장인배관 전화번호 010-3409-5404"
            className="!relative w-auto h-full max-h-16"
          />
        </div>
      </div>
    </div>
  );
};

export default Blog;

const parseString = require("xml2js").parseString;

const ParseData = ({ data }: { data: any[] }) => {
  const dataArr: {
    title: any;
    link: any;
    description: any;
    pubDate: any;
    category: any;
  }[] = [];

  parseString(data, (err: any, result: any) => {
    if (err) {
      console.error("XML 파싱 에러:", err);
      return;
    }

    const items = result?.rss?.channel?.[0]?.item;
    if (Array.isArray(items)) {
      items.slice(0, 9).forEach((v: any) => {
        dataArr.push({
          title: v.title,
          link: v.link,
          description: v.description,
          pubDate: v.pubDate,
          category: v.category,
        });
      });
    } else {
      console.warn("item 배열이 없습니다.");
    }
  });

  return dataArr;
};
